export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Regular House Cleaning',
      description: 'Keep your home consistently clean with our weekly or bi-weekly cleaning services. Perfect for busy families and professionals.',
      features: ['Dusting & Vacuuming', 'Kitchen Cleaning', 'Bathroom Sanitizing', 'Floor Mopping']
    },
    {
      icon: 'ri-sparkling-2-line',
      title: 'Deep Cleaning',
      description: 'Comprehensive top-to-bottom cleaning that reaches every corner. Ideal for seasonal cleaning or special occasions.',
      features: ['Detailed Scrubbing', 'Appliance Cleaning', 'Baseboards & Walls', 'Window Cleaning']
    },
    {
      icon: 'ri-truck-line',
      title: 'Move In/Out Cleaning',
      description: 'Make your transition smooth with our thorough move-in or move-out cleaning services. Leave or enter a spotless space.',
      features: ['Empty Home Cleaning', 'Cabinet Interiors', 'All Surfaces', 'Final Touch-ups']
    },
    {
      icon: 'ri-building-line',
      title: 'Office Cleaning',
      description: 'Maintain a professional and healthy work environment with our commercial cleaning services for offices and businesses.',
      features: ['Desk & Surface Cleaning', 'Restroom Sanitizing', 'Break Room Cleaning', 'Trash Removal']
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Post-Construction Cleaning',
      description: 'Remove dust, debris, and construction residue to reveal your beautiful new or renovated space.',
      features: ['Dust Removal', 'Paint Splatter Cleanup', 'Window Washing', 'Final Detailing']
    },
    {
      icon: 'ri-shirt-line',
      title: 'Carpet & Upholstery',
      description: 'Professional deep cleaning for carpets, rugs, and upholstered furniture to remove stains and refresh fabrics.',
      features: ['Steam Cleaning', 'Stain Removal', 'Odor Elimination', 'Fabric Protection']
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive cleaning solutions tailored to your needs. From regular maintenance to specialized deep cleaning, we've got you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-2xl sm:text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}